import { Component } from "@angular/core";
import { NavController, NavParams, ViewController } from "ionic-angular";
import { TermsofusePage } from "../termsofuse/termsofuse";
import { PrivacypolicyPage } from "../privacypolicy/privacypolicy";
import { CookiesPage } from "../cookies/cookies";
import { ScTermsConditionsPage } from "../sc-terms-conditions/sc-terms-conditions";
import { LegalFannelInfoPage } from "../legal-fannel-info/legal-fannel-info";
import { ConfigService } from "../../services/config.service";

@Component({
  selector: "page-legal",
  templateUrl: "legal.html"
})
export class LegalPage {
  termsOfUse = TermsofusePage;
  privacyPolicy = PrivacypolicyPage;
  SCTerms = ScTermsConditionsPage;
  cookies = CookiesPage;
  legalFannel = LegalFannelInfoPage;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private configService: ConfigService,
    public viewCtrl: ViewController
  ) {}

  ionViewDidLoad() {
    console.log("ionViewDidLoad LegalPage");
  }

  ionViewWillEnter() {}
}



// WEBPACK FOOTER //
// ./src/pages/legal/legal.ts